// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bbt_a bhm_a bhm_q bhm_j bhm_wl bhm_bj","ImgResponsive__img":"bbt_b bhm_b bhm_ql"};